<template>
  <transition
    name="fade"
    mode="out-in"
    :duration="{ enter: 1000, leave: 200 }"
  >
    <BaseLoading v-if="isMatchGoalsLoading" />
    <template v-else-if="performances.length">
      <div>
        <TheAthleteGoalsOverviewCard
          v-for="performance in performances"
          :id="performance.athlete.id"
          :key="`performance-${performance.id}`"
          :name="performance.athlete.name"
          :avatar="performance.athlete.image"
          :team="performance.athlete.team"
          :time="performance.time"
          :value="performance.value"
          :category="performance.category.name"
          :is-selected="false"
          :gif="performance.gif"
        />
      </div>
    </template>
    <BaseAlert
      v-else
      variant="light"
      is-center
    >
      {{ $t('nobody-has-scored-in-this-match-yet') }}
    </BaseAlert>
  </transition>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import TheAthleteGoalsOverviewCard from '@/components/Molecules/TheAthleteGoalsOverviewCard'
import BaseLoading from '@/components/Atoms/BaseLoading'
import BaseAlert from '@/components/Atoms/BaseAlert'
export default {
  name: 'MatchPublicGoals',
  components: { BaseAlert, BaseLoading, TheAthleteGoalsOverviewCard },
  data() {
    return {
      matchId: `${this.$route.params.league}/${this.$route.params.match}`,
    }
  },
  computed: {
    ...mapState({
      isMatchGoalsLoading: state => state['matches/matchGoals'].isMatchGoalsLoading,
    }),
    performances() {
      return this.$store.getters['matches/matchGoals/getMatchGoals'](this.matchId)
    },
  },
  created() {
    this.fetchMatchGoals({
      matchId: this.matchId,
    })
  },
  methods: {
    ...mapActions({
      fetchMatchGoals: 'matches/matchGoals/fetchMatchGoals',
    }),
  },
}
</script>

<style scoped>

</style>
